<ng-content *ngIf="visible"></ng-content>


